import FullScreenIcon from '@material-ui/icons/ZoomOutMap';
import FullScreenExitIcon from '@material-ui/icons/FullscreenExit';
import PencilIcon from '@material-ui/icons/Create';
import GridIcon from '@material-ui/icons/GridOn';
import CompareIcon from '@material-ui/icons/SyncAlt';
import CloseIcon from '@material-ui/icons/Close';

import { useEffect, useState } from "react";
import {  Tooltip } from "@material-ui/core";
import EditorView from "./EditorView";
import GridView from "./GridView";
import CompareView from "./CompareView";
import { useRecoilState, useRecoilValue } from "recoil";
import { planEditorVisibleState } from "../../store/PlanEditorVisibleState";
import { routePointEditingState } from "../../store/RoutePointEditingState";
import { OnClickAnchor } from "../../parts/OnClickAnchor";

function PlanEditorPanel() {
  const [planEditorVisible, setPlanEditorVisible] = useRecoilState(planEditorVisibleState);
  const routePointEditing = useRecoilValue(routePointEditingState);
  const [fullScreen, setFullScreen] = useState('');
  const [mode, setMode] = useState('pen');
  const [widgetWidth, setWidgetWidth] = useState('');
  const [widgetHeight, setWidgetHeight] = useState('');
  const [screenModeTooltipVisible, setScreenModeTooltipVisible] = useState(false);
  const [resized, setResized] = useState(false);

  const screenMode = fullScreen === '' ?
    <FullScreenIcon onMouseEnter={()=>{setScreenModeTooltipVisible(true)}} onMouseLeave={()=>{setScreenModeTooltipVisible(false)}}/>
    : <FullScreenExitIcon onMouseEnter={()=>{setScreenModeTooltipVisible(true)}} onMouseLeave={()=>{setScreenModeTooltipVisible(false)}}/>;

  const changeExpand = () => {
    setScreenModeTooltipVisible(false);
    if (fullScreen === '') {
      const w = document.getElementById('plan-widget-body').style.width;
      const h = document.getElementById('plan-widget-body').style.height;
      setWidgetWidth(w);
      setWidgetHeight(h);
      document.getElementById('plan-widget-body').style.width = '';
      document.getElementById('plan-widget-body').style.height = '';
    } else {
      document.getElementById('plan-widget-body').style.width = widgetWidth;
      document.getElementById('plan-widget-body').style.height = widgetHeight;
    }
    setFullScreen(fullScreen === '' ? 'full-screen' : '');
  };
  const closeClickHandler = () => {
    setPlanEditorVisible(!planEditorVisible);
  }

  useEffect(() => {
    const widgetBody = document.getElementById('plan-widget-body');
    if(widgetBody) {
      const observer = new MutationObserver(() => {
        if(widgetBody.style.height) {
          setResized(true);
        }
      });
      observer.observe(widgetBody, {attributes: true, attributeFilter: ['style']});
    }
  },[]);

  const hidden = !planEditorVisible || routePointEditing;
  
  return (
    <div className={`widget-box plan-editor dark-color ${fullScreen}`} hidden={hidden}>
      <div className="widget-header"><h4>Plan Editor</h4>
        <div className="widget-toolbar">
          <OnClickAnchor onClick={()=>{setMode('pen')}}>
            <Tooltip title="Text Mode" arrow >
              <PencilIcon/>
            </Tooltip>
          </OnClickAnchor>
          <OnClickAnchor onClick={()=>{setMode('grid')}}>
            <Tooltip title="Grid Mode" arrow >
              <GridIcon/>
            </Tooltip>
          </OnClickAnchor>
          <OnClickAnchor onClick={()=>{setMode('compare')}}>
            <Tooltip title="Compare Mode" arrow >
              <CompareIcon/>
            </Tooltip>
          </OnClickAnchor>
          <OnClickAnchor onClick={changeExpand}>
            <Tooltip title={fullScreen === '' ? "Fullscreen" : "exit Fullscreen"} arrow open={screenModeTooltipVisible}>
              {screenMode}
            </Tooltip>
          </OnClickAnchor>
          <OnClickAnchor onClick={closeClickHandler}>
            <Tooltip title="Close Plan Editor" arrow >
              <CloseIcon/>
            </Tooltip>
          </OnClickAnchor>
        </div>
      </div>
      <div id="plan-widget-body" className="widget-body">
        {mode === 'pen' && <EditorView/>}
        {mode === 'grid' && <GridView fullScreen={fullScreen} resized={resized}/>}
        {mode === 'compare' && <CompareView/>}
      </div>
    </div>
  )
}

export default PlanEditorPanel;